import { useAuth } from "@/contexts/AuthContext";
import AppLogo from "@/components/AppLogo";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-3" data-testid="auth-loading">
        <AppLogo className="w-12 h-12 rounded-lg object-cover" />
        <div className="text-muted-foreground text-sm font-mono">Loading Infoz IT Solutions…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
